import SmileysCsatWidget from './SmileysCsatWidget';
export default SmileysCsatWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/SmileysCsatWidget/index.js